export default {
  get: {
    url: '/api/user/get',
    method: 'get'
  },
  getAll: {
    url: '/api/user/getAll',
    method: 'get'
  },
  create: {
    url: '/api/user/create',
    method: 'post'
  },
  update: {
    url: '/api/user/update',
    method: 'put'
  },
  delete: {
    url: '/api/user/delete',
    method: 'delete'
  },
  setPassword: {
    url: '/api/user/setPassword',
    method: 'post'
  },
  updatePassword: {
    url: '/api/user/updatePassword',
    method: 'post'
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js